<template>
  <InputComponent class="yes-no-switch" v-bind="$attrs">
    <ChoiceComponent :values="choiceValues" v-model="comp"> </ChoiceComponent>
  </InputComponent>
</template>

<script>
import { ChoiceComponent } from 'vue-elder-choice'
import InputComponent from '../components/Input.vue'
import { ValueComp } from '../utils'

export default {
  props: ['value', 'default'],
  computed: {
    comp: ValueComp(),
    choiceValues() {
      return [
        { value: true, label: this.$t('yes') },
        { value: false, label: this.$t('no') },
      ]
    },
  },

  components: {
    ChoiceComponent,
    InputComponent,
  },
}
</script>

<style lang="scss">
.yes-no-switch {
  border: none;
  max-width: fit-content;

  .elder-input {
    &__field {
      border: none;
    }
    &__value {
      align-items: center;
    }
  }
  .elder-choices {
    max-width: fit-content;
    border-radius: var(--border-radius);
    border: 1px solid var((--border-color));
    margin: 0;
    gap: 0rem;
    padding: 0.25rem;
    background-color: white;
    flex-wrap: nowrap;
    &__item {
      margin: 0;
      font-weight: normal;
      border: none;
      border-radius: var(--border-radius);
      background-color: white;

      &--active {
        background-color: var(--secondary);
        color: var(--secondary-contrast);
      }

      &-label {
        padding: 0.5rem 1.25rem;
      }
    }
  }
}
</style>
